import React, { useEffect, useState } from 'react'
import Button from '../../../../component/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ConfirmationModal from '../../../../modalComponents/ConfirmationModal';
import CustomerInformation from './CustomerInformation';
import EnquireMessage from './EnquireMessage';
import ProductDetails from './ProductDetails';
import EnquiryResponseModal from '../../../../modalComponents/EnquiryResponseModal';
import SuccessModal from '../../../../modalComponents/SuccessModal';
import request from '../../../../service';
import Exported from '../../../../service/endpoints';
import { Toast } from '../../../../service/toast';
import { useDispatch } from 'react-redux';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
const EnquiryDetails = (props) => {

    const { } = props
    const [markResolvedPopUp, setMarkResolvedPopUp] = useState(false)
    const [sendResponsePopUp, setSendResponsePopUp] = useState(false)
    const [showSuccessPopUp, setShowSuccessPopUp] = useState(false)
    const [enquiryData, setEnquiryData] = useState([])
    // const [viewData, setViewData] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()
    const pathName = location?.search?.split('?id=')
    const params = pathName[1]
    const dispatch = useDispatch()


    const redirectBack = () => {
        navigate('/admin/product-enquiry')
    }

    const handleClose = () => {
        setMarkResolvedPopUp(false)
    }

    const handleSuccessClose = () => {
        setShowSuccessPopUp(false)
        redirectBack()
    }

    const handleSendResponse = () => {
        setSendResponsePopUp(false)
        setShowSuccessPopUp(true)
    }

    const resolvedProduct = () => {
        setMarkResolvedPopUp(false)
        resolveIssue(params)
    }
    const specificProduct = async (id) => {
        await request({
            url: `${Exported.Endpoints.productEnquiry}?enquiry_id=${id}`,
            method: Exported.APIMethods.GET
        }).then((res) => {
            const obj = {
                result: res?.data?.data
            }
            setEnquiryData([res?.data?.data]);
            console.log(res.data.data, "res")

        }).catch((err) => {
            console.log(err, "err");
        })
    }

    const resolveIssue = async (id) => {
        dispatch(saveLoadingState(true))
        await request({
            url: `${Exported.Endpoints.resolveProduct}?enquiry_id=${id}`,
            method: Exported.APIMethods.PUT,
            data: {
                enquiry_id: id,
            }
        }).then((res) => {
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data
                }
                Toast({
                    type: 'success',
                    message: 'Status updated successfully'
                })
                navigate('')
            }
        }).catch((err) => {
            console.log(err, "err");
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }
    const onSubmit = (data) => {
        const requestData = {
            enquiry_id: params,
            customer_email: data.email,
            subject: data.subject,
            message: data.message
        }
        request({
            url: Exported.Endpoints.mailToCustomer,
            method: Exported.APIMethods.POST,
            data: requestData
        }).then((res) => {
            console.log(res, "mail")
            if (res?.data?.status) {
                handleSendResponse()
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    };


    useEffect(() => {
        if (location?.pathname) {
            specificProduct(params)
        }
    }, [])
    return (
        <>

            <div className={``}>
                <div className={`w-[100%] flex items-center justify-between`}>
                    <div className={`layout-title flex items-center`}>
                        <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                            <ArrowBackIosOutlinedIcon />
                        </div>
                        <div>Enquiry Details</div>
                    </div>
                    {
                        enquiryData?.map((item) => (
                            item.status !== 3 &&
                            <div className='flex items-center'>
                                <Button text={"Mark as Resolved"} className={`mr-4 `} smallBtn secondary onClick={() => setMarkResolvedPopUp(true)} />
                                <Button text={"Send a Response"} className={``} style={{ cursor: item.status == 2 ? 'default' : 'pointer' }} smallBtn onClick={() => item.status == 2 ? null : setSendResponsePopUp(true)} disabled={item.status == 2 ? true : false} />
                            </div>
                        ))}
                </div>
                {
                    enquiryData?.map((item, index) => (
                        <div className='my-8'>
                            <EnquireMessage enquiryID={item?.enquiry_id} enquiryMessgae={item?.enquiry_message} comments={item?.admin_email_message} admin={item?.admin_comment} />
                            <CustomerInformation name={item?.user?.name} type={item?.user?.role?.name} email={item?.user?.email} mobile={item?.user?.mobileNumber} />
                            <ProductDetails quantity={item?.product?.quantity} referenceNumber={item?.product?.reference_number} type={item?.product?.category?.title} />
                        </div>
                    ))
                }
            </div>

            {
                markResolvedPopUp ?
                    <ConfirmationModal
                        isOpen={markResolvedPopUp}
                        handleSuccess={resolvedProduct}
                        closePopUp={handleClose}
                        warningText={'Confirmation'}
                        modalText={'Are you sure to mark this as resolved?'}
                        confirmText={'Yes'}
                        cancelText={'No'}
                        primaryBtnConfirm={false}
                    />
                    : null
            }
            {
                sendResponsePopUp ?
                    <EnquiryResponseModal isOpen={sendResponsePopUp} closePopUp={setSendResponsePopUp} handleSuccess={handleSendResponse} onSubmit={onSubmit} value={enquiryData.map((it) => it?.user?.email)[0] || ''}
                    />
                    : null
            }
            {
                showSuccessPopUp ?
                    <SuccessModal
                        isOpen={showSuccessPopUp}
                        closePopUp={handleSuccessClose}
                        successText={'Success!'}
                        modalText={'Response Sent Successfully'}
                    />
                    : null
            }

        </>
    )
}

export default EnquiryDetails